import { ref } from 'vue'
import { useCssVar } from '@vueuse/core'
import { defineStore } from 'pinia'

export enum PageTheme {
  Default,
  FrontpagePublic,
  TeacherGuideTheme,
  AnchorNavigationPage,
  LicensePage,
  CataloguePage,
}

export const useLayoutStore = defineStore('layout', () => {
  const isFullWidthLayout = ref<boolean>(false)
  const pageTheme = ref<PageTheme>(PageTheme.Default)

  const setIsFullWidthLayout = (newValue: boolean) => isFullWidthLayout.value = newValue
  const setTheme = (theme: PageTheme) => {
    let bgColor, color, bgColorHex

    switch (theme) {
      case PageTheme.Default:
      default:
        bgColor = 'var(--color-yellow-10)'
        color = 'var(--color-blue-50)'
        bgColorHex = useCssVar('--color-yellow-10')
        break
      case PageTheme.FrontpagePublic:
        bgColor = 'var(--color-blue-50)'
        color = 'var(--color-coral-20)'
        bgColorHex = useCssVar('--color-blue-50')
        break
      case PageTheme.TeacherGuideTheme:
        bgColor = 'var(--color-violet-10)'
        color = 'var(--color-red-50)'
        bgColorHex = useCssVar('--color-violet-10')
        break
      case PageTheme.AnchorNavigationPage:
        bgColor = 'var(--color-green-10)'
        color = 'var(--color-blue-50)'
        bgColorHex = useCssVar('--color-green-10')
        break
      case PageTheme.LicensePage:
        bgColor = 'var(--color-orange-20)'
        color = 'var(--color-blue-50)'
        bgColorHex = useCssVar('--color-blue-50')
        break
      case PageTheme.CataloguePage:
        bgColor = 'var(--color-yellow-20)'
        color = 'var(--color-blue-50)'
        bgColorHex = useCssVar('--color-yellow-50')
        break
    }
    document.documentElement.style.setProperty('--app-theme-background-color', bgColor)
    document.documentElement.style.setProperty('--app-theme-color', color)
    document.querySelector('meta[name="theme-color"]')?.setAttribute('content', bgColorHex.value ?? '')
  }

  return {
    isFullWidthLayout,
    pageTheme,
    setIsFullWidthLayout,
    setTheme,
  }
})
